module.exports = __webpack_public_path__ + "img/Bayer-Leverkusen.f1351d9b.png";